var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgXIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27269 4L7.73642 1.53627C8.08786 1.18483 8.08786 0.615031 7.73642 0.263585C7.38495 -0.0878616 6.81519 -0.0878616 6.46373 0.263585L4 2.72731L1.53627 0.263585C1.18483 -0.0878616 0.615031 -0.0878616 0.263585 0.263585C-0.0878616 0.615031 -0.0878616 1.18483 0.263585 1.53627L2.72731 4L0.263585 6.46373C-0.0878616 6.81517 -0.0878616 7.38497 0.263585 7.73642C0.439308 7.91212 0.669614 8 0.899921 8C1.13023 8 1.36055 7.91214 1.53626 7.73642L4 5.27269L6.46373 7.73642C6.63945 7.91212 6.86975 8 7.10006 8C7.33037 8 7.56067 7.91214 7.7364 7.73642C8.08784 7.38497 8.08784 6.81517 7.7364 6.46373L5.27269 4Z",
    fill: "#EA3458"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.df169074edfa42faccee9d85ecac3e22.svg";
export { ForwardRef as ReactComponent };